import React, { Component } from "react";
import Frame from "./Frame";

class RenderContainer extends Component {
  state = {
    src: null
  };

  componentDidMount() {
    const { url } = this.props;
    if (process.env.NODE_ENV === "development") {
      import("axios").then(axios => {
        axios
          .get(`${url}&dev_url=${window.location.origin}`, {
            responseType: "blob"
          })
          .then(response => {
            this.setState({ src: URL.createObjectURL(response.data) });
          })
          .catch(err => {
            debugger;
          });
      });
    } else {
      this.setState({ src: url });
    }
  }

  render() {
    const { src } = this.state;
    return <Frame src={src} />;
  }
}

export default RenderContainer;
